import { Injectable } from '@angular/core';
import {Client} from '../../models/client';
import {Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ClienEventService {
    private clientArchiveEvent = new Subject<{ client: Client, is_archive: boolean }>();

    // Emit event when a client is archived or unarchived
    emitClientArchiveEvent(client: Client, is_archive: boolean) {
        this.clientArchiveEvent.next({ client, is_archive });
    }

    // Subscribe to archive/unarchive events
    onClientArchiveEvent() {
        return this.clientArchiveEvent.asObservable();
    }
}
